import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import WatermarkImageListImagesScreen from "./WatermarkImageListImagesScreen";

function WatermarkImageMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Batch Watermark Images For Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/watermark_image", title: "Bulk Watermark Images Free" },
    data2: { link: "/watermark_image", title: "Protect Digital Pictures" },
    data3: { link: "/watermark_image", title: "Batch Watermark Images" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Batch watermark images online easily. Add text or logo watermarks to multiple images at once with our fast and secure image watermark tool."
      ></meta>
      <meta
        name="keywords"
        content="batch watermark images, bulk image watermark, add watermark to images, image watermark tool, watermark images online, batch image watermarking, bulk watermark photos, add logo to images, text watermark images, image branding tool, watermark photos in bulk, online image watermark, protect images online, image copyright tool, watermark images free, stamp images, image stamp tool, copyright images, copyright photos online, overlay text on image, overlay text on photo,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <WatermarkImageListImagesScreen
          title={title}
        ></WatermarkImageListImagesScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{
              "image/jpeg": [".jpg", ".jpeg"],
              "image/png": [".png"],
              "image/webp": [".webp"],
              "image/bmp": [".bmp"],
              "image/svg+sml": [".svg"],
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Batch Watermark Images website provides a fast, secure, and efficient solution for adding watermarks to multiple images at once without requiring an internet connection. Designed to work fully offline, this powerful tool allows users to protect photos directly on their device, ensuring complete privacy and data security. Whether you need to bulk watermark images for branding, copyright protection, or professional use, this platform makes it easy to add text or logo watermarks to large image collections in just a few clicks. Supporting popular formats like JPG, PNG, and WebP, the tool works as a reliable solution to watermark photos while preserving image quality. Users can also choose optional online functionality, making it flexible enough to act as a stamp images online tool when needed, while still offering the advantages of offline processing. With customizable options such as watermark position, opacity, size, rotation, and batch processing, this website is ideal for photographers, designers, businesses, and content creators. Optimized for speed and usability, it helps protect digital assets efficiently while improving workflow productivity. If you are looking for a secure batch watermark images tool, a fast way to bulk watermark images, or an easy to use solution to watermark photos with offline support, this website delivers a complete image protection solution." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Watermark",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Watermark Images"
            why_use={[
              {
                title: "Protect Image Copyright and Ownership",
                description:
                  "Our batch watermark images tool helps protect photos from unauthorized use by adding visible ownership marks. Using bulk watermark images ensures copyright protection across large image collections.",
              },
              {
                title: "Save Time with Bulk Processing",
                description:
                  "Our batch watermark images solution allows users to watermark photos in bulk, applying the same watermark to multiple images at once and saving significant time.",
              },
              {
                title: "Offline Watermarking for Privacy",
                description:
                  "This offline batch watermark images tool processes files directly on your device, keeping images private without uploading them to a stamp images online service.",
              },
              {
                title: "Maintain Brand Consistency",
                description:
                  "Using a bulk watermark images tool ensures consistent logos, text, and branding across all images, helping businesses maintain a professional visual identity.",
              },
              {
                title: "Preserve Image Quality",
                description:
                  "Advanced watermark photos tools apply watermarks without reducing image clarity, ensuring high-quality output even when processing images in batches.",
              },
              {
                title: "Ideal for Photographers and Creators",
                description:
                  "Photographers, designers, and content creators rely on batch watermark images tools to protect portfolios, client work, and social media content.",
              },
              {
                title: "Customizable Watermark Settings",
                description:
                  "Our bulk watermark images solution offers control over watermark size, opacity, position, and rotation, allowing users to customize how they watermark photos.",
              },
              {
                title: "Faster Content Publishing",
                description:
                  "Batch watermark images tools speed up workflows by preparing watermarked images quickly for websites, blogs, and social media platforms.",
              },
              {
                title: "Supports Multiple Image Formats",
                description:
                  "Our reliable batch watermark images tool supports JPG, PNG, WebP, and other formats, making it suitable for diverse image workflows.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1631645001}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default WatermarkImageMain;
